import React from 'react';
import Loading from '../Loading';
import styles from './FullPageLoading.css';

const FullPageLoading = () => (<div
    className={styles.wrap}
>
    <Loading size={40} />
</div>);

export default FullPageLoading;



// WEBPACK FOOTER //
// ./src/client/Components/FullPageLoading/FullPageLoading.js